import { Typography } from '@mui/material';
import type { FC } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VrsCallCommentsHelperText } from 'features/call/vrs-call-comments/components';
import type { AbuseReasonValue } from 'features/call/vrs-call-comments/enums';
import { useVrsCallCommentsReasonOptions } from 'features/call/vrs-call-comments/hooks';
import type { VrsCallCommentsAbuseFormControl } from 'features/call/vrs-call-comments/interfaces';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Select } from 'features/ui/elements';

interface VrsCallCommentsReasonSelectControlProps extends VrsCallCommentsAbuseFormControl {
  commentReason: AbuseReasonValue;
}

export const VrsCallCommentsReasonSelectControl: FC<
  VrsCallCommentsReasonSelectControlProps
> = ({ control, commentReason }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'abuseCommentText',
  });
  const { getReasonOptions } = useVrsCallCommentsReasonOptions();

  return (
    <>
      <Typography variant='label' color={theme.palette.grey[50]} mt={4}>
        {t('scenario')}
      </Typography>
      <Controller
        control={control}
        name='commentScenario'
        rules={{ required: true }}
        render={({ field: { ref, ...args }, fieldState }) => (
          <>
            <CategorySelect
              {...args}
              inputRef={ref}
              dropdownWidth={440}
              placeholder={t('placeholder')}
              options={getReasonOptions(commentReason)}
            />
            {fieldState.error && (
              <VrsCallCommentsHelperText>
                {t('reasonValidation')}
              </VrsCallCommentsHelperText>
            )}
          </>
        )}
      />
    </>
  );
};

const CategorySelect = styled(Select)`
  margin-top: ${theme.spacing(3)};
`;
